export const columns = [
    {dataIndex:"id",key:"id",title:"序号",scopedSlots: { customRender: 'tindex' }},
    {dataIndex:"name",key:"name",title:"合同名称"},
    {dataIndex:"price",key:"price",title:"合同金额"},
    {dataIndex:"yiDate",key:"yiDate",title:"签署日期"},
    {dataIndex:"yi",key:"yi",title:"乙方姓名"},
    {dataIndex:"yiPhone",key:"yiPhone",title:"乙方电话"},
    {dataIndex:"yiWorkPlace",key:"yiWorkPlace",title:"乙方所在工地"},
    {dataIndex:"isMoneyGive",key:"isMoneyGive",title:"是否拨款",scopedSlots: { customRender: 'bokuan' }},
    {dataIndex:"id",key:"action",title:"操作",align:"center",scopedSlots: { customRender: 'action' }},
]